export class ErrorMessage {
  message: string;
  title: string;
  statusCode: string | number;
  error: {
    message: string;
  };
}
